import { connect } from 'react-redux'
import AccordionItem from '../../components/AccordionList/accordionItem'
import {
  deVerrouillerTournee,
  updateCheckTouree,
  verrouillerTournee,
} from '../../redux/simulateTournee/actions'

const mapDisptachToProps = (dispatch) => ({
  updateCheckTouree: (deselection, id) => {
    dispatch(updateCheckTouree(deselection, id))
  },
  verrouillerTournee: (idDriver) => {
    dispatch(verrouillerTournee(idDriver))
  },
  deVerrouillerTournee: (idDriver) => {
    dispatch(deVerrouillerTournee(idDriver))
  },
})

export default connect(null, mapDisptachToProps)(AccordionItem)
